export default __webpack_public_path__ + "static/media/devblog.cfa8be5a.png";